/* eslint-disable */
import React from 'react';
import './index.css'

const QuestionPreview = ({ formData, questionTypeCode }) => {

  const createMarkup = (html) => {
    return { __html: html };
  };

  // Render MCQ options
  const renderMCQOptions = () => {
    if (!formData.options || formData.options.length === 0) return null;

    return (
      <div className="space-y-3 mt-4">
        {formData.options.map((option, index) => (
          <div
            key={index}
            id={`preview-option-${option.label}`}
            className={`p-4 border-2 rounded-lg transition-colors ${formData.correctAnswer === option.label ||
                Array.isArray(formData.correctAnswer) && formData.correctAnswer.includes(option.label)
                ? 'border-green-500 bg-green-50'
                : 'border-gray-300 bg-white'
              }`}
          >
            <div className="flex items-start gap-3">
              <span className="font-semibold text-gray-700 min-w-[24px]">{option.label}.</span>
              <div
                className="flex-1"
                dangerouslySetInnerHTML={createMarkup(option.value)}
              />
              {(formData.correctAnswer === option.label ||
                (Array.isArray(formData.correctAnswer) && formData.correctAnswer.includes(option.label))) && (
                  <svg
                    className="w-5 h-5 text-green-600 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Render passage if exists
  const renderPassage = () => {
    if (!formData.passageText) return null;

    return (
      <div className="mb-6 p-6 bg-gray-50 rounded-lg border border-gray-200" id="preview-passage">
        {/* {formData.passageTitle && (
          <h4 className="text-lg font-semibold text-gray-900 mb-3">
            {formData.passageTitle}
          </h4>
        )} */}
        <div
          className="prose prose-sm max-w-none text-gray-700"
          dangerouslySetInnerHTML={createMarkup(formData.passageText)}
        />
      </div>
    );
  };
const renderExplanation = () => {
    if (!formData.textExplanation) return null;

    return (
      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200" id="preview-explanation">
        <h5 className="text-sm font-semibold text-blue-900 mb-2">Explanation:</h5>
        <div
          className="rich-text-preview text-blue-800 text-sm"  
          dangerouslySetInnerHTML={createMarkup(formData.textExplanation)}
        />
      </div>
    );
};
  // Render explanation if exists
  // const renderExplanation = () => {
  //   if (!formData.textExplanation) return null;

  //   return (
  //     <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200" id="preview-explanation">
  //       <h5 className="text-sm font-semibold text-blue-900 mb-2">Explanation:</h5>
  //       <div
  //         className="prose prose-sm max-w-none text-blue-800"
  //         dangerouslySetInnerHTML={createMarkup(formData.textExplanation)}
  //       />
  //     </div>
  //   );
  // };

  // Render multiple questions for PASSAGE_MULTI
  const renderPassageMultipleQuestions = () => {
    if (!formData.questions || formData.questions.length === 0) return null;

    return (
      <div className="space-y-6">
        {formData.questions.map((question, index) => (
          <div key={index} className="p-6 border border-gray-200 rounded-lg bg-white" id={`preview-sub-question-${index}`}>
            <div className="flex items-start gap-3 mb-4">
              <span className="flex-shrink-0 w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-semibold text-sm">
                {index + 1}
              </span>
              <div className="flex-1">
                <div
                  className="prose prose-sm max-w-none"
                  dangerouslySetInnerHTML={createMarkup(question.questionText)}
                />
                <div className="mt-2 flex items-center gap-4 text-xs text-gray-500">
                  <span>Marks: {question.marks}</span>
                  {question.negativeMarks && question.negativeMarks !== '0' && (
                    <span>Negative Marks: {question.negativeMarks}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="space-y-3">
              {question.options?.map((option, optIndex) => (
                <div
                  key={optIndex}
                  id={`preview-sub-option-${index}-${option.label}`}
                  className={`p-4 border-2 rounded-lg ${question.correctAnswer === option.label
                      ? 'border-green-500 bg-green-50'
                      : 'border-gray-300 bg-white'
                    }`}
                >
                  <div className="flex items-start gap-3">
                    <span className="font-semibold text-gray-700">{option.label}.</span>
                    <div
                      className="flex-1"
                      dangerouslySetInnerHTML={createMarkup(option.value)}
                    />
                    {question.correctAnswer === option.label && (
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {question.textExplanation && (
              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                <h6 className="text-xs font-semibold text-blue-900 mb-1">Explanation:</h6>
                <div
                  className="prose prose-sm max-w-none text-blue-800 text-sm"
                  dangerouslySetInnerHTML={createMarkup(question.textExplanation)}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-6" id="question-preview">
      {/* Question Header */}
      <div className="flex items-center justify-between pb-4 border-b border-gray-200" id="preview-header">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Question Preview</h3>
          <p className="text-sm text-gray-500 mt-1">
            Type: <span className="font-medium">{questionTypeCode}</span> •
            Difficulty: <span className="font-medium capitalize">{formData.difficultyTag}</span>
            {formData.marks && questionTypeCode !== 'PASSAGE_MULTI' && (
              <>
                {' '}• Marks: <span className="font-medium">{formData.marks}</span>
              </>
            )}
          </p>
        </div>
      </div>

      {/* Passage (for PASSAGE_SINGLE and PASSAGE_MULTI) */}
      {(questionTypeCode === 'PASSAGE_SINGLE' || questionTypeCode === 'PASSAGE_MULTI' || questionTypeCode === 'JEEPASSAGE' || questionTypeCode === 'CLATPASSAGE') && 
        renderPassage()}

      {/* Question Content */}
      {(questionTypeCode !== 'PASSAGE_MULTI' && questionTypeCode !== 'JEEPASSAGE' && questionTypeCode !== 'CLATPASSAGE') ? (
        <>
          {/* Single Question */}
          <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Question:</h4>
            <div
              className="prose prose-sm max-w-none p-4 bg-gray-50 rounded-lg"
              id="preview-question-text"
              dangerouslySetInnerHTML={createMarkup(formData.questionText)}
            />
          </div>

          {/* Options for MCQ */}
          {(questionTypeCode === 'MCQ' || questionTypeCode === 'JEEMCQ1' || questionTypeCode === 'JEEMCQ2' || questionTypeCode === 'MCQ_MULTI' || questionTypeCode === 'PASSAGE_SINGLE') &&
            renderMCQOptions()}

          {/* Numeric Answer */}
          {questionTypeCode === 'NUMERIC' || questionTypeCode === 'JEENUMERIC'  && (
            <div className="p-4 bg-green-50 border-2 border-green-500 rounded-lg" id="preview-numeric-answer">
              <p className="text-sm font-medium text-gray-700">Answer Type:</p>
              <p className="text-base font-semibold text-gray-900 capitalize mb-2">
                {formData.answerType}
              </p>

              {formData.answerType !== 'range' && formData.acceptableAnswers && (
                <>
                  <p className="text-sm font-medium text-gray-700 mt-2">Acceptable Answer(s):</p>
                  <p className="text-base font-semibold text-gray-900">
                    {formData.acceptableAnswers}
                  </p>
                </>
              )}
              {formData.answerType === 'range' && (
                <div className="flex gap-6 mt-2">
                  <div>
                    <p className="text-sm font-medium text-gray-700">Min Value:</p>
                    <p className="text-base font-semibold text-gray-900">{formData.min_value || '—'}</p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-700">Max Value:</p>
                    <p className="text-base font-semibold text-gray-900">{formData.max_value || '—'}</p>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Explanation */}
          {renderExplanation()}

          {formData.youtubeVideoUrl && (
            <div className="mt-4">
              <h5 className="text-sm font-semibold text-gray-700 mb-2">Video Explanation:</h5>

              <a href={formData.youtubeVideoUrl}
                target="_blank"
                rel="noopener noreferrer"
                id="preview-video-url"
                className="text-indigo-600 hover:text-indigo-700 text-sm underline"
              >
                {formData.youtubeVideoUrl}
              </a>
            </div>
          )}
        </>
      ) : (
        /* Multiple Questions for PASSAGE_MULTI */
        <>
          <h4 className="text-base font-medium text-gray-900">Questions:</h4>
          {renderPassageMultipleQuestions()}
        </>
      )}
    </div>
  );
};

export default QuestionPreview;